var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { startOfDay, endOfDay } from 'date-fns';
import qs from 'qs';
import { preOrderRequest as api } from '../../api';
import { usePreOrderRequestColumn } from '../../hooks/useColumns';
import { useOffice } from '../../hooks/useOffice';
import { useRequest } from '../../hooks/requestHook';
import useFetch from '../../hooks/useFetch';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import PageLayout from '../atoms/PageLayout';
import DateRangeFilter from '../molecules/DateRangeFilter';
import { useNotify } from '../../hooks/notificationHook';
import DownloadPreOrderRequestsCSVButton from '../organisms/DownloadPreOrderRequestsCSVButton';
var AdminPreOrderRequestsListPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var officeItems = useOffice().officeItems;
    var preOrderRequestColumns = usePreOrderRequestColumn('admin');
    var getAll = useRequest(api.getAll);
    var update = useRequest(api.update);
    var notify = useNotify();
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var renderDateRangeFilter = React.useCallback(function (props) { return React.createElement(DateRangeFilter, __assign({}, props)); }, []);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, preOrderRequestColumns.offerListName), { field: 'offerList.name', filtering: true, sorting: true, defaultFilter: defaultFilter('offerList.name') }),
        __assign(__assign({}, preOrderRequestColumns.lotNumber), { field: 'offer.lotNumber', filtering: true, sorting: true, defaultFilter: defaultFilter('offer.lotNumber') }),
        __assign(__assign({}, preOrderRequestColumns.roasterId), { filtering: true, defaultFilter: defaultFilter('roaster.id') }),
        __assign(__assign({}, preOrderRequestColumns.roasterName), { field: 'roaster', filtering: true, defaultFilter: defaultFilter('roaster') }),
        __assign(__assign({}, preOrderRequestColumns.roasterCommunityManager), { filtering: true, defaultFilter: defaultFilter('roaster.communityManager') }),
        __assign(__assign({}, preOrderRequestColumns.roasterCountryOfficeName), { sorting: true, filtering: true, lookup: officeItems, defaultFilter: defaultFilter('roaster.country.office.name') }),
        preOrderRequestColumns.roasterCompany,
        preOrderRequestColumns.roasterStoreName,
        __assign(__assign({}, preOrderRequestColumns.mailSentAt), { filtering: true, sorting: true, filterComponent: renderDateRangeFilter, defaultFilter: defaultFilter('mailSentAt') }),
        __assign(__assign({}, preOrderRequestColumns.status), { filtering: true, defaultFilter: defaultFilter('status') }),
        preOrderRequestColumns.weight,
        preOrderRequestColumns.processing,
        preOrderRequestColumns.variety,
        preOrderRequestColumns.notes,
        __assign(__assign({}, preOrderRequestColumns.requestedAt), { filtering: true, sorting: true, filterComponent: renderDateRangeFilter, defaultFilter: defaultFilter('requestedAt') }),
    ]; }, [defaultFilter, preOrderRequestColumns, renderDateRangeFilter, officeItems]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'status':
                    q.with_status = filter.value;
                    break;
                case 'roaster':
                    q.roaster_firstname_or_roaster_lastname_cont = filter.value;
                    break;
                case 'roaster.communityManager':
                    q.roaster_community_manager_name_cont = filter.value;
                    break;
                case 'roaster.country.office.name':
                    q.roaster_country_office_name_in = filter.value;
                    break;
                case 'roaster.id':
                    q.roaster_id_eq = filter.value;
                    break;
                case 'mailSentAt':
                case 'requestedAt':
                    buildDateRangeQuery(filter, q);
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            case 'offer.offerList.name':
                return 'offer_lists.name';
            case 'offer.lotNumber':
                return 'offers.lot_number';
            case 'roaster.country.office.name':
                return 'offices.name';
            case 'roaster.id':
                return 'roaster_id';
            default:
                return decamelize(order);
        }
    }, []);
    var fetchPreOrderRequests = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        buildOrder: buildOrder,
    });
    var isEditable = React.useCallback(function (data) {
        if (data.status === 'mail_sent')
            return false;
        return true;
    }, []);
    var handleUpdate = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, update({
                        id: data.id,
                        pre_order_request: {
                            status: data.status,
                            processings: data.processings,
                            varieties: data.varieties,
                            weight: data.weight,
                            notes: data.notes,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, update]);
    var buildFilterParamsForCSV = React.useCallback(function (filters) {
        return buildFilterParams({
            filters: Object.entries(filters).map(function (_a) {
                var field = _a[0], value = _a[1];
                return ({
                    column: { field: field },
                    operator: '=',
                    value: value,
                });
            }),
        });
    }, []);
    var csvParams = React.useMemo(function () {
        return urlQuery.filters
            ? {
                q: buildFilterParamsForCSV(urlQuery.filters),
            }
            : undefined;
    }, [urlQuery]);
    return (React.createElement("div", null,
        React.createElement(PageLayout, { title: t('pages.preOrderRequest.title'), actions: React.createElement(DownloadPreOrderRequestsCSVButton, { params: csvParams }) },
            React.createElement(MaterialTable, { model: "preOrderRequest", columns: columns, data: fetchPreOrderRequests, options: {
                    filtering: true,
                    filterCellStyle: {
                        minWidth: 100,
                    },
                    paging: true,
                    initialPage: initialPage,
                    pageSize: pageSize,
                }, editable: {
                    isEditable: isEditable,
                    onRowUpdate: handleUpdate,
                } }))));
};
export default AdminPreOrderRequestsListPage;
var buildDateRangeQuery = function (filter, query) {
    var field = decamelize(filter.column.field);
    if (!field)
        return query;
    if (filter.value.startedAt) {
        query["".concat(field, "_gteq")] = startOfDay(new Date(filter.value.startedAt));
    }
    if (filter.value.endedAt) {
        query["".concat(field, "_lteq")] = endOfDay(new Date(filter.value.endedAt));
    }
    return query;
};
